export default __webpack_public_path__ + "static/media/Background_00020.d694103b.png";